
class Analytics {
    static trackers = {};

    /** Add a new tracker
     *  provide settings object. This requires a type property indicating the type of tracker to use.
     */
    static addTracker(tracker){
        const trackerId = Math.round(99999 * Math.random());
        Analytics.trackers[trackerId] = tracker;
        return trackerId;
    }

    static removeTracker(trackerId){
        if(Analytics.trackers[trackerId]){
            Analytics.trackers[trackerId].remove();
            delete Analytics.trackers[trackerId];
            return true;
        }
        return false;
    }

    /*  Track a page view. You can provide details in the details object, or leave it empty to auto-populate
        it. Adding a trackerId is optional and allows you to target specific trackers. If the trackerId is
        omitted it will send the page view to all trackers.*/
    static trackPageView(details = {}, optionalTrackerId = null){
        const settings = {
            title: document.title,
            location: window.location.href,
            path: window.location.pathname + window.location.hash,
            ...details
        };
        if(optionalTrackerId !== null){
            Analytics.trackers[optionalTrackerId].trackPageView(settings);
            return;
        }

        for(const id of Object.keys(Analytics.trackers)){
            Analytics.trackers[id].trackPageView(settings);
        }
    }

    /*  Track an event. You can provide details in the details object. Adding a trackerId is optional and
        allows you to target specific trackers. If the trackerId is omitted it will send the page view to all
        trackers.*/
    static trackEvent(details = {}, optionalTrackerId = null){
        if(! details || ! details.action){
            console.error('Error sending analytics event. Required setting action is missing.');
            return;
        }
        const settings = {
            category: details.category || 'default category',
            label: details.label || 'no label',
            value: details.value || 1,
            ...details
        };
        if(optionalTrackerId !== null){
            Analytics.trackers[optionalTrackerId].trackEvent(settings);
            return;
        }
        for(const id of Object.keys(Analytics.trackers)){
            Analytics.trackers[id].trackEvent(settings);
        }
    }
};

export {Analytics};
